/**
 * Builds the URL of a sized image variant, e.g.
 *   photo.jpg + "_480" -> photo_480.jpg
 *
 * Image fields are not reliably strings: `property.image` is declared as a
 * String in the API schema but some records hold null or an array of URLs, and
 * gallery entries can be missing. Since this runs during render, throwing here
 * unmounts the whole React tree — one bad record blanks an entire page. So a
 * non-string input returns "" and the caller falls back to its placeholder.
 */
const getImageVariantUrl = (baseUrl: any, variantSuffix: any): string => {
  if (typeof baseUrl !== "string" || !baseUrl) return "";
  return baseUrl.replace(/(\.[\w\d_-]+)$/i, `${variantSuffix}$1`);
};

export default getImageVariantUrl;
